module.exports = __webpack_public_path__ + "img/eg-6.9d12c6cf.png";